/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Done_MarkedInputs */

const en_cook_done_marked = /** @type {(inputs: Cook_Done_MarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marked as cooked in the plan`)
};

const de_cook_done_marked = /** @type {(inputs: Cook_Done_MarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Plan als gekocht vermerkt`)
};

/**
* | output |
* | --- |
* | "Marked as cooked in the plan" |
*
* @param {Cook_Done_MarkedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_done_marked = /** @type {((inputs?: Cook_Done_MarkedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Done_MarkedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_done_marked(inputs)
	return en_cook_done_marked(inputs)
});